<template>
  
  <div class="chartDtc">
      <div class="chartItemTitulo">Histórico de Falhas</div>
      <div class="tableDTC">
        <table id="stiloTableDTC">
          <tr>
            <th>Código</th>
            <th>Descrição</th>
            <th>Natureza</th>
            <th>Data</th>
           </tr>
            <tr>
              <td>H46-1</td>
              <td>Baixa Tensão - Célula 1</td>
              <td>Warning</td>
              <td>07/02/20-18:08h</td>
            </tr>
            <tr>
              <td>H201</td>
              <td>SOC menor que 20%</td>
              <td>Info</td>
              <td>07/02/20-17:24h</td>
            </tr>
            <tr>
              <td>H45-1</td>
              <td>Alta Tensão - Célula 1</td>
              <td>Warning</td>
              <td>07/02/20-15:22h</td>
            </tr>
            <tr>
              <td>H302-6</td>
              <td>Erro NTC - Célula 6</td>
              <td>Error</td>
              <td>30/01/20-10:35h</td>
            </tr>
            <tr>
              <td>H300-6</td>
              <td>Atuação devido baixa Temp. - Célula 6</td>
              <td>Warning</td>
              <td>30/01/20-10:34h</td>
            </tr>
            <tr>
              <td>H301-2</td>
              <td>Atuação devido baixa Temp. - Célula 2</td>
              <td>Warning</td>
              <td>30/01/20-10:27h</td>
            </tr>

          </table>
      </div>
  </div>

</template>

<script>

export default {
    name: 'ChartDTC'
}
</script>

<style>
.chartDtc {
  position: relative;
  width:100%;
  min-width: 200px;
  height: 100%;
  min-height: 300px;
}
.tableDTC {
  margin-top:60px;
  width: 100%;
  background: white;
}

#stiloTableDTC {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#stiloTableDTC td, #stiloTableDTC th {
  border: none;
  padding: 8px;
  color: #2e2d2c;
}

#stiloTableDTC tr:nth-child(even){background-color: #f2f2f2;}

#stiloTableDTC tr:hover {background-color: #ddd;}

#stiloTableDTC th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #008fac;
  color: white;
}
</style>